import moment from 'moment';
import {
  setWorkers,
  setTasksModalData,
  setCalendarData,
} from '../store/actions/calendarActions';
import {
  setRequestDrawerVisible,
  setSelectedRequestId,
} from '../../../actions/requestCardActions';
import { slotTime, cellHeight } from '../constants/common';

export const isAfterStartPeriod = (date, startPeriod, granularity = 'day') =>
  moment(date).isSameOrAfter(startPeriod, granularity);

export const isBeforeEndPeriod = (date, endPeriod, granularity = 'day') =>
  moment(date).isSameOrBefore(endPeriod, granularity);

export const getUpdatedTask = (data, eventId) => {
  for (let i = 0; i < data.length; i++) {
    const task = data[i].tasks.find((taskItem) => taskItem.id === eventId);

    if (task) {
      return task;
    }
  }

  return undefined;
};

export const filterDataById = (data, entityId) =>
  data.filter((item) => item.id !== entityId);

export const getFilteredData = (data, taskId) =>
  data.map((item) => {
    const filteredTasks = filterDataById(item.tasks, taskId);
    item.tasks = filteredTasks;
    return item;
  });

export const checkIfWorkerExists = (data, workerId) =>
  data.find((item) => item.tasks.some((task) => task.worker.id === workerId));

export const updateNewCalendarStoreAfterDeletingEvent = (
  calendarData,
  tasksModalData,
  workers,
  eventId,
  executerId,
  dispatch,
  closeTaskDrawer = false
) => {
  const updatedCalendarData = getFilteredData(calendarData, eventId);

  const hasWorkerInTasks = checkIfWorkerExists(updatedCalendarData, executerId);

  let updatedWorkers;

  if (!hasWorkerInTasks) {
    updatedWorkers = filterDataById(workers, executerId);
  } else {
    updatedWorkers = workers.map((worker) => {
      if (worker.id === executerId) {
        worker.requestCount -= 1;
      }

      return worker;
    });

    dispatch(setWorkers);
  }

  if (tasksModalData) {
    const updatedTasks = filterDataById(tasksModalData.tasks, eventId);

    const newTasksModalData = { ...tasksModalData, tasks: updatedTasks };

    dispatch(setTasksModalData(newTasksModalData));
  }

  dispatch(setCalendarData(updatedCalendarData));

  if (updatedWorkers) {
    dispatch(setWorkers(updatedWorkers));
  }

  if (closeTaskDrawer) {
    dispatch(setRequestDrawerVisible(false));
    dispatch(setSelectedRequestId(null));
  }
};

export const getHeight = (num, heightTask, calendarData) => (num / slotTime) * cellHeight(heightTask, calendarData);
